import Vue from "vue";
const mixin = {
  created: function() {},
  methods: {
    getMessageText(msg) {
      let val;
      if (msg) {
        val = msg.Text_vod__c;
      }
      return val;
    },
    replaceMessageText(msg, replace) {
      let val;
      if (msg) {
        const text = replace && replace.Text_vod__c ? replace.Text_vod__c : replace;
        val = msg.Text_vod__c.replace("{0}", text);
      }
      return val;
    }
  }
};
Vue.mixin(mixin);
export default mixin;
